import React from 'react';
import { useSelectable } from '.';
import Icon from '../Icons/Icon';
import Dropdown from '../Dropdown';
import { Transition } from '@headlessui/react';
import { classNames } from '../../Services/helpers';

const TheSelectableBar = ({hideWhenNotSelecting, options, className, sticky}) => {
    const {isSelecting, selected, allSelected, toggleAllSelected} = useSelectable();

    return <div className={classNames(sticky && 'sticky -top-5 bg-white z-40')}>
        <Transition
            show={!hideWhenNotSelecting || isSelecting}
        >
            <div className={classNames(
                // Base styles
                'transition ease-in-out duration-150 opacity-100 max-h-[100px]',
                // Shared closed styles
                'data-[closed]:opacity-0 data-[closed]:max-h-0 data-[closed]:overflow-hidden',
            )}>
                <div className={classNames('flex flex-row p-2 rounded-xl border', className)}>
                    <div className="grow-0 shrink-0 px-2 flex items-center" onClick={toggleAllSelected}>
                        <Icon size="2x" icon={allSelected ? 'SquareCheck' : 'Square'} className="mr-2" />
                        {selected.length} selected
                    </div>
                    <div className="grow">
                    </div>
                    <div className="grow-0 shrink-0 px-2">
                        <Dropdown options={options} />
                    </div>
                </div>
            </div>
        </Transition>
    </div>
}

export default TheSelectableBar;
